module.exports = __webpack_public_path__ + "static/media/mobile-browser-development.965b69e3.svg";